import { render } from "./UploadFilesManager.vue?vue&type=template&id=3c2718ca&scoped=true&lang=pug"
import script from "./UploadFilesManager.vue?vue&type=script&lang=js"
export * from "./UploadFilesManager.vue?vue&type=script&lang=js"

import "./UploadFilesManager.vue?vue&type=style&index=0&id=3c2718ca&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/quasar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2718ca"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QIcon,QBtn,QTooltip,QInnerLoading,QSpinnerDots});qInstall(script, 'directives', {Ripple});
